import { useTranslation } from 'react-i18next';
import {
  ContactDetails,
  DraftBanner,
  OperatorDetails,
  PageIntro,
  ProseSections,
  useTranslatedList,
  type ProseSection,
} from './shared';

/** Review fix F11: plain-language DRAFT terms pending Mauro's and legal review. No legal entity,
 * jurisdiction, refund or liability terms are invented -- the page says they aren't final. */
export function Terms() {
  const { t } = useTranslation();
  const sections = useTranslatedList<ProseSection>('public.terms.sections');
  return (
    <div className="prose">
      <PageIntro title={t('public.terms.title')} lead={t('public.terms.lead')} />
      <DraftBanner />
      <ProseSections sections={sections} idPrefix="terms" />
      <section className="prose-section" aria-labelledby="terms-operator">
        <h2 id="terms-operator">{t('public.terms.operatorHeading')}</h2>
        <OperatorDetails />
        <ContactDetails />
      </section>
    </div>
  );
}
